<template>
    <div id="programActivity" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="shopHeader" v-if="$route.params.id > 0">Update Program Activity</span>
                    <span class="page-title" id="shopHeader" v-else>Add Program Activity</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWorkOrderTemplateList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content wo-template-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ProgramActivityForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col-md-3 form-group">
                                        <label> Program </label>
                                        <v-select v-model="program_id" id="program_id" name="program_id" label="text" @input="programChange($event)" :filterable="false" :options="programArr" @search="onSearchProgram" placeholder="Search Program" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Program Name...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <hr class="light-hr"/>
                                <div class="purchase-charges-deatil-label workorder-template-section">
                                    <h5 class="color-blue font-semibold">Template Item</h5>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" class="require">Component</th>
                                                    <th scope="col" class="require">Task</th>
                                                    <th scope="col">Description</th>
                                                    <th scope="col" class="text-center">Action </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(template, index) in templateArr" :key="index">
                                                    <td style="width:40%">
                                                        <v-select v-model="template.item_category_id" name="item_category_id" placeholder="Select Component."
                                                                    label="text" class="close-remove"
                                                                    :options="vmrsArr" @search="onSearchVMRS" :filterable="false">
                                                        </v-select>
                                                        <div class="field-error">{{template.component_error_msg}}</div>
                                                    </td>
                                                    <td style="width:40%">
                                                        <v-select v-model="template.work_order_task_id" name="work_order_task_id" placeholder="Select Task."
                                                                    label="text" class="close-remove"
                                                                    :options="workOrderTaskArr">
                                                        </v-select>
                                                        <div class="field-error">{{template.task_error_msg}}</div>
                                                    </td>
                                                    <td style="width:40%">
                                                        <input type="text" v-model="template.description" name="description" placeholder="Enter Description."
                                                                    label="text" class="form-control">

                                                        <!-- <div class="field-error">{{template.task_error_msg}}</div> -->
                                                    </td>
                                                    <td class="text-center" valign="center">
                                                        <template v-if="templateArr.length != 1">
                                                            <i class="fp-close color-red close-icon cursor-pointer" v-on:click="removeLine(index)"> </i>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                                        <i class="fp-add"> </i> Add Template Item
                                    </button>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="createActivityBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateProgramActivity" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createActivityBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateProgramActivity" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueActivityBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateProgramActivity(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelActivityBtn" class="btn btn-tertiary" v-on:click.prevent="BackWorkOrderTemplateList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import { contractMixins } from '../mixins/contractMixins';


export default {
  name: "ProgramActivityCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Program Activity | " +process.env.COPYRIGHT_NAME : "Create Program Activity | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins, contractMixins],
  data: () => ({

    program_id: null,

    vmrsArr: [],
    workOrderTaskArr: [],
    templateArr: [],

    loading:false,
    permissions: [],
    cantAccessPage: "",
    programId:0,
    program_error_msg:'',
    fromUrl:"",

  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_work_order_template') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['workordertask']);

        self.templateArr.push({
            template_id:0,
            item_category_id: null,
            work_order_task_id: null,
            description:'',
            component_error_msg: "",
            task_error_msg: "",
        })

        if( self.$route.params.id){

            self.programId = self.$route.params.id;
            self.loadActivityData(self.programId);
        }
        if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
          self.fromUrl = atob(self.$route.query.fromUrl);
        }

  },
  methods: {
      onSearchProgram(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'program', '');
            }
        },

    programChange(event){
        console.log("type chenged..."+JSON.stringify(event));

        var self = this;
        console.log('evt program value => '+event.value)
        console.log('evt program text => '+event.text)

        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/program-activity/fetch",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                template_id: event.value
            },
            success: function (data) {
                self.loading = false;
                self.templateArr = [];
                if (data.code == 200) {

                    console.log("JSON Response = >" + JSON.stringify(data.content))

                    for ( var i=0; i<data.content.length; i++ ) {

                        self.templateArr.push({
                            template_id:(data.content[i].template_id != undefined && data.content[i].template_id != null && data.content[i].template_id != '')?data.content[i].template_id:0,
                            item_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_code + " | " + data.content[i].component_category_name)}:null,
                            work_order_task_id: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,
                            description:data.content[i].description,
                            task_error_msg: "",
                            component_error_msg: ""
                        })

                    }

                }else if(data.code = 201){

                    self.templateArr.push({
                        template_id:0,
                        item_category_id: null,
                        work_order_task_id: null,
                        description:'',
                        component_error_msg: "",
                        task_error_msg: "",
                    })

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true,'get-workorder-template');
            }
        });

    },

    loadActivityData(id){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/program-activity/fetch",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                template_id: id
            },
            success: function (data) {
                self.loading = false;
                self.templateArr = [];
                if (data.code == 200) {

                    console.log("JSON Response = >" + JSON.stringify(data.content))

                    for ( var i=0; i<data.content.length; i++ ) {

                        self.templateArr.push({
                            template_id:(data.content[i].template_id != undefined && data.content[i].template_id != null && data.content[i].template_id != '')?data.content[i].template_id:0,
                            item_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_code + " | " + data.content[i].component_category_name)}:null,
                            work_order_task_id: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,
                            description:data.content[i].description,
                            task_error_msg: "",
                            component_error_msg: ""
                        })

                    }

                    if ( data.content[0] && data.content[0].templateId){

                        self.program_id = data.content[0].templateId;

                    }else{
                        self.loadPrograms();
                    }

                }else if(data.code = 201){
                    self.loadPrograms();
                    self.templateArr.push({
                        template_id:0,
                        item_category_id: null,
                        work_order_task_id: null,
                        description:'',
                        component_error_msg: "",
                        task_error_msg: "",
                    })

                }
            },
            error: function (jqXHR, exception) {
                self.loadPrograms();
                self.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true,'get-wo-template');
            }
        });
    },

    BackWorkOrderTemplateList() {
      var self = this;
      if ( self.fromUrl != "" && self.fromUrl != null ) {
            var url = self.fromUrl;
            self.redirectPageUrl(url);
            return;
      }else{
        self.$router.push("/program-asset/list/"+self.programId);
      }

    },

    CreateProgramActivity(flag) {

        var self = this;
        var error = false;

        self.program_error_msg = "";

        if (!self.program_id || self.program_id == null || self.program_id == "") {
            self.program_error_msg = "Program Required.";
            error = true;
        }

        for (var i=0; i<self.templateArr.length; i++) {

            self.templateArr[i].component_error_msg = "";
            self.templateArr[i].task_error_msg = "";

            if (self.templateArr[i].work_order_task_id == null || self.templateArr[i].work_order_task_id == "" || self.templateArr[i].work_order_task_id == 0) {
                self.templateArr[i].task_error_msg = "Task Required.";
                error = true;
            }

            if (self.templateArr[i].item_category_id == null || self.templateArr[i].item_category_id == "" || self.templateArr[i].item_category_id == 0) {
                self.templateArr[i].component_error_msg = "Component Required.";
                error = true;
            }



        }

      if (!error) {

            // PR - For Template Item
            var templateIdsArr = [];
            var componentArr = [];
            var taskArr = [];
            var descArr = [];

            // alert('Array length..'+self.chargesArr.length);
            for (var i = 0; i<self.templateArr.length;i++) {

                templateIdsArr.push(self.templateArr[i].template_id);
                componentArr.push(self.templateArr[i].item_category_id.value);
                taskArr.push(self.templateArr[i].work_order_task_id.value);
                descArr.push(self.templateArr[i].description);
            }

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createActivityBtn").val("Updating ...");
                $("#createActivityBtn").prop("disabled", true);
                $("#cancelActivityBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue" || flag == "Save and add") {

                    $("#createAndContinueActivityBtn").val("Saving ...");
                    $("#createActivityBtn").prop("disabled", true);
                    $("#createAndContinueActivityBtn").prop("disabled", true);
                    $("#cancelActivityBtn").prop("disabled",true);

                }else{

                    $("#createActivityBtn").val("Saving ...");
                    $("#createActivityBtn").prop("disabled", true);
                    $("#createAndContinueActivityBtn").prop("disabled", true);
                    $("#cancelActivityBtn").prop("disabled",true);
                }

            }

            var fields = $("#ProgramActivityForm").serializeArray();
            fields.push({name: "templateIdsArr", value: templateIdsArr});
            fields.push({name: "componentArr", value: componentArr});
            fields.push({name: "taskArr", value: taskArr});
            fields.push({name: "description", value: descArr});
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "program_id", value: self.program_id.value});

            $.ajax({
                url: process.env.ROOT_API + "/program-activity/store",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createActivityBtn").val("Update");
                        $("#createActivityBtn").prop("disabled", false);
                        $("#cancelActivityBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueActivityBtn").val("Save and Continue");
                            $("#createActivityBtn").prop("disabled", false);
                            $("#createAndContinueActivityBtn").prop("disabled", false);
                            $("#cancelActivityBtn").prop("disabled",false);

                        }else{

                            $("#createActivityBtn").val("Save");
                            $("#createActivityBtn").prop("disabled", false);
                            $("#createAndContinueActivityBtn").prop("disabled", false);
                            $("#cancelActivityBtn").prop("disabled",false);
                        }

                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.maintenance_type_id = null;
                            self.templateArr = [];
                            self.templateArr.push({
                                template_id:0,
                                item_category_id: null,
                                work_order_task_id: null,
                                description:'',
                                task_error_msg: "",
                                component_error_msg: ""
                            })

                        }else if (flag == "Save and add"){

                            self.$router.push("/asset/list?from=recall");

                        }else{
                            self.$router.push("/program-asset/list/"+self.programId);
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createActivityBtn").val("Update");
                        $("#createActivityBtn").prop("disabled", false);
                        $("#cancelActivityBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            self.name = "";
                            $("#createAndContinueActivityBtn").val("Save and Continue");
                            $("#createActivityBtn").prop("disabled", false);
                            $("#createAndContinueActivityBtn").prop("disabled", false);
                            $("#cancelActivityBtn").prop("disabled",false);

                        }else{

                            $("#createActivityBtn").val("Save");
                            $("#createActivityBtn").prop("disabled", false);
                            $("#createAndContinueActivityBtn").prop("disabled", false);
                            $("#cancelActivityBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR, false,'workorder-template-create');
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadPrograms() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/program/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                console.log(data);
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;

                    self.program_id = {text:data.content.name,value:data.content.id};

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-type-load-by-id')
            }
        });
    },

    addLine () {

        var self = this;

        var index=self.templateArr.length-1;
        self.templateArr[index].task_error_msg = "";
        self.templateArr[index].component_error_msg = "";

        console.log('self.templateArr -> '+JSON.stringify(self.templateArr));

        if ( self.templateArr[index].item_category_id != null && self.templateArr[index].work_order_task_id != null ) {

            self.templateArr.push({
                template_id:0,
                item_category_id: null,
                work_order_task_id: null,
                description:'',
                task_error_msg: "",
                component_error_msg: ""
            })

        } else {

            if (self.templateArr[index].item_category_id == null || self.templateArr[index].item_category_id == "" ) {
                self.templateArr[index].component_error_msg = "Component Required.";
            }

            if (self.templateArr[index].work_order_task_id == null || self.templateArr[index].work_order_task_id == "") {
                self.templateArr[index].task_error_msg = "Task Required.";
            }

        }

    },

    removeLine (index) {

        var self = this;

        if (self.templateArr[index].template_id == 0) {
            self.templateArr.splice(index, 1);

        }
        else {

            if (confirm('Are you sure that you want to remove this line? ')) {

                $.ajax({
                    url: process.env.ROOT_API + "/program-activity/remove-item",
                    type: "POST",
                    data: {'id': self.templateArr[index].template_id},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        if (data.status == "success") {
                            self.templateArr.splice(index, 1);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true,'remove-workorder-template-item');

                    },
                });
            }
        }
    },
    onSearchVMRS(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vmrs', '');
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProgramActivityCreate.vue